import React from 'react';

// Custom SVG Icons
const LaunchIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
  </svg>
);

const FileIcon = ({ className }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
  </svg>
);

const AccountManagementDetails = ({ ticket }) => {
  // Helper function to safely render values
  const renderValue = (value) => {
    if (!value) return 'Not specified';
    if (typeof value === 'object') {
      if (value.name) return value.name;
      return JSON.stringify(value);
    }
    return String(value);
  };

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4 font-poppins text-blue-600">
        Account Request Details
      </h3>
      <div className="space-y-4">
        <div className="py-2">
          <div className="text-sm font-medium text-gray-600 mb-1 font-poppins">Email</div>
          <div className="text-gray-900 font-poppins">{renderValue(ticket.email)}</div>
        </div>
        <div className="py-2">
          <div className="text-sm font-medium text-gray-600 mb-1 font-poppins">Account Type</div>
          <div className="text-gray-900 font-poppins">{renderValue(ticket.accountType)}</div>
        </div>
        <div className="py-2">
          <div className="text-sm font-medium text-gray-600 mb-1 font-poppins">Action Type</div>
          <div className="text-gray-900 font-poppins">{renderValue(ticket.actionType)}</div>
        </div>
        <div className="py-2">
          <div className="text-sm font-medium text-gray-600 mb-1 font-poppins">Subject</div>
          <div className="text-gray-900 font-poppins">{renderValue(ticket.subject)}</div>
        </div>
      </div>

      {/* Shortcut Links Section */}
      <div className="mt-6 mb-4">
        <h4 className="text-lg font-semibold text-blue-600 mb-4 font-poppins">
          Shortcut Links
        </h4>
        <div className="space-y-6">
          {/* Gmail Forms */}
          <div>
            <h5 className="text-base font-medium mb-3 font-poppins">Gmail Account Forms</h5>
            <a
              href="https://depedph-my.sharepoint.com/:x:/g/personal/icts_imus_deped_gov_ph/EeXmLbZsXjVEm3WORbJPGqwBLBDtctSQ2gwk5uQ8zGyYhA"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 border border-blue-600 text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 hover:border-blue-700 transition-colors font-medium font-poppins"
            >
              <FileIcon className="w-4 h-4" />
              Access Gmail Forms (Creation & Reset)
              <LaunchIcon className="w-4 h-4" />
            </a>
          </div>

          {/* M365 Form */}
          <div>
            <h5 className="text-base font-medium mb-3 font-poppins">M365 Account Form</h5>
            <a
              href="https://docs.google.com/spreadsheets/d/1BYwMpR5GSgKU6z1F6bBJQ8m0YARCFvG0tEJnGgMmXyA/edit?gid=1081583692#gid=1081583692"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 border border-blue-600 text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 hover:border-blue-700 transition-colors font-medium font-poppins"
            >
              <FileIcon className="w-4 h-4" />
              Access M365 Creation Form
              <LaunchIcon className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountManagementDetails; 